import React from 'react'
import { EmptyContent } from '@ztechapps/webui.util'
import { useAssetPageContext } from './Context'
import { UploadViaUppy } from './UploadViaUppy'

export const EmptyAssets = () => {
  const { canEdit } = useAssetPageContext()

  return (
    <EmptyContent
      action={canEdit && <UploadViaUppy uploadText="Upload your first asset" />}
      icon="cloud-arrow-up"
      message="No assets yet"
      subMessage="Upload images, videos, or documents to keep everything organized in one place."
    />
  )
}
